import React, {useState} from "react";
import {usePublicTimeseriesIncidentsQuery} from "./query";
import IncidentsGraphsBase from "./IncidentGraphsBase";


const IncidentsGraphsPublic = () => {
    const [selectedRegionId, setSelectedRegionId] = useState();
    const timeseriesQuery = usePublicTimeseriesIncidentsQuery({filters: {region_id: selectedRegionId}});

    return <IncidentsGraphsBase timeseriesQuery={timeseriesQuery}
                                regionId={selectedRegionId}
                                setSelectedRegionId={setSelectedRegionId}/>;
}


export default IncidentsGraphsPublic;